import { WhenEnergyUsedMostEnum } from "./contract/generated/electrify-v1";
import { ITaskTypes } from "@origin-digital/reporting-client";

/** TTL: 4 hrs */
export const TTL = 4 * 3600 * 1000; // {hour} * 3600 seconds * 1000 milliseconds
export const TTL_KEY = "ttl" as const;

export const SESSIONID_KEY = "sessionId";
export const SERVICEPROVIDERIDS = "serviceProviderIds";

export const VOWELS = new Set(["a", "e", "i", "u", "o"]);

export const USAGE_PATTERNS = {
  [WhenEnergyUsedMostEnum.MAINLY_DURING_THE_DAY]: "mainly during the day",
  [WhenEnergyUsedMostEnum.BOTH_DURING_THE_DAY_AND_IN_THE_EVENING]:
    "pretty even during the day and evenings",
  [WhenEnergyUsedMostEnum.EVENING]: "mainly in the evenings",
  [WhenEnergyUsedMostEnum.IN_THE_EVENING_AND_ON_THE_WEEKENDS]:
    "in the evening and all weekend",
};

export const screenNames = {
  gettingStart: "/",
  customerType: "customer-type",
  contactDetail: "contact-detail",
  roofMaterial: "roof-material",
  systemTypeAndAddress: "system-type-and-address",
  solarGeneration: "solar-generation",
  batteryOutlook: "battery-outlook",
  customerContact: "customer-contact",
  ratProcessing: "rat-processing",
  ratResultsVerify: "rat-results-verify",
  existingSolar: "existing-solar",
  averageBill: "average-bill",
  threePhase: "three-phase",
  largeAppliances: "large-appliances",
  usagePattern: "usage-pattern",
  recommendation: "recommendation",
  serviceProviderMatching: "service-provider-matching",
  softQuote: "soft-quote",
  requestingQuote: "requesting-quote",
  confirmation: "confirmation",
  hardStop: "not-able-to-provide-quotes",
  solarBatteryOutlook: "solar-battery-outlook",
} as const;

export const TRANSPARENT_BACKGROUND_SCREENS = [
  screenNames.ratProcessing,
  screenNames.ratResultsVerify,
  screenNames.recommendation,
  screenNames.serviceProviderMatching,
  screenNames.requestingQuote,
];

export const ANALYTICS_FORM_NAME = "quote";
export const ANALYTICS_TASK_TYPE = "request-quote";
export const ANALYTICS_TASK_TYPE_MAP: { [key in string]: ITaskTypes } = {
  solar: "solar-request-quote",
  "solar and battery": "solar-battery-request-quote",
  battery: "battery-request-quote",
};
